import { defineComponent, PropType, ref, watch } from 'vue'
import { MsHeadline, CsRadioButton, CsTooltipModal, CsSecondaryButton, CsTooltip } from '@sunrise/components'
import { MsInformationCircle } from '@sunrise/icons'
import { screenSizeDetection } from '@sunrise/shared'
import { SurroundingOptions } from '../filter.types'

export default defineComponent({
    name: 'CsSurroundingArea',
    components: {
        CsRadioButton,
        CsSecondaryButton,
        CsTooltip,
        CsTooltipModal,
        MsInformationCircle,
        MsHeadline,
    },
    model: {
        prop: 'modelValue',
        event: 'update:modelValue',
    },
    props: {
        modelValue: { type: String as PropType<SurroundingOptions>, default: SurroundingOptions.REGIONAL },
    },
    emits: ['update:modelValue', `onMouseEnter`, `onMouseLeave`, `close`, 'update:visible'],
    setup(props, { emit }) {
        const model = ref(props.modelValue)
        const tooltipComponent = ref<Element | null>(null)
        const isTooltipOpen = ref(true)
        const { isScreenM } = screenSizeDetection()
        const isModalOpen = ref([false, false])

        watch(
            () => props.modelValue,
            (modelValue) => {
                model.value = modelValue
            },
        )

        const searchOptions = [
            { value: SurroundingOptions.REGIONAL, text: 'Regional', key: 1 },
            { value: SurroundingOptions.NATIONWIDE, text: 'Überrregional', key: 2 },
        ]

        function onUpdate(modelValue: SurroundingOptions) {
            emit('update:modelValue', modelValue)
        }

        function openModal(index: number) {
            isModalOpen.value[index] = true
        }

        function onUpdateVisible(index: number) {
            isModalOpen.value[index] = false
        }

        return {
            onUpdate,
            MsInformationCircle,
            model,
            searchOptions,
            onUpdateVisible,
            tooltipComponent,
            isTooltipOpen,
            isScreenM,
            openModal,
            isModalOpen,
        }
    },
})
